<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      size="medium"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_process_name') || '工序名称'"
            prop="processesName"
          >
            <el-input
              v-model="formData.processesName"
              maxlength="250"
              show-word-limit
              clearable
              :placeholder="
                $l('form_placeholder_processes_name') || '请输入工序名称'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_process_remarks') || '工序备注'">
            <el-input
              v-model="formData.processesDesc"
              :placeholder="
                $l('form_placeholder_processes_remarks') || '请输入工序备注'
              "
              clearable
              type="textarea"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    techProcessesCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    techCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        processesName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_processes_name') || '请输入工序名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techProcessesCode) return
      this.$api
        .techProcessesDetailApi({
          techProcessesCode: this.techProcessesCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const params = {
        ...this.formData,
        orderCode: this.orderCode,
        techCode: this.techCode,
      }

      this.loadingOpen()
      this.$api
        .techProcessesSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
